import { AuthService } from './services/auth.service';
import { AuthStoreFacade } from './facades/auth-store.facade';
import { AuthProvider } from './providers/auth.provider';
import Vue from 'vue';

export class AuthModule extends Vue {

  Store = new AuthStoreFacade();
  Services = AuthService;
  Provider = AuthProvider;

}